import {Component, Input} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ErrorTemplate} from "projects/store/src/app/interfaces";

@Component({
  selector: 'app-sales-error-message-template',
  templateUrl: './sales-error-message-v2.component.html'
})
export class SalesErrorMessageV2Component {
  color = '';
  code: string;
  copyClipboardButtonLabel = 'Copiar información';
  @Input() error!: ErrorTemplate;

  constructor(private route: ActivatedRoute) {
    this.code = this.route.snapshot.queryParams['tracking_number'];
  }

  getIconPosition(): 'left' | 'right' {
    return (this.error.button?.iconPos as 'left' | 'right') || 'left';
  }

  onCopy(data: any) {
    navigator.clipboard.writeText(btoa(JSON.stringify(data)));
    const tempText = this.copyClipboardButtonLabel;
    this.copyClipboardButtonLabel = 'Copiado...';
    setTimeout(() => this.copyClipboardButtonLabel = tempText, 2000);
  }
}

@Component({
  selector: 'app-sales-status-message',
  templateUrl: './sales-error-message-v3.component.html',
})
export class SalesErrorMessageV3Component extends SalesErrorMessageV2Component { }
